import $ from 'jquery';

import { URL_JOBS_PARAM } from './constants';

export const createColorStyles = ({ color_profile: { hsl } }) => {
    return {
        '--h': hsl[0],
        '--s': hsl[1] + '%',
        '--l': hsl[2] + '%'
    };
};

export const createMapPathUrl = (selectedJobs) => {
    const url = new URL(window.location.href);

    if (selectedJobs && selectedJobs.length) {
        url.searchParams.set(URL_JOBS_PARAM, selectedJobs.join(','));
    } else {
        url.searchParams.delete(URL_JOBS_PARAM);
    }

    return url.href.replaceAll('%2C', ',');
}

export const updateMapPathUrl = (url) => {
    window.history.pushState(null, document.title, url);
}

export const copyToClipBoard = (text) => {
    const cb = navigator.clipboard;
    cb.writeText(text);
}

export const getScrollBarWidth = () => {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}

export const scrollToAnchor = (e) => {
    e.preventDefault();

    const target = e.currentTarget.getAttribute('href');

    if(target.length) {
        $('html,body').stop().animate({ scrollTop: $(target).offset().top }, 1000);
    }
}

export const showModal = (modalElement) => {
    document.body.classList.add('modal-opened');

    const scrollBarWidth = getScrollBarWidth();

    if (scrollBarWidth > 0) {
        document.body.style.paddingRight = scrollBarWidth + 'px';
    }

    $(modalElement).css('height', window.innerHeight);
    $(modalElement).fadeIn(/*400, () => $(modalElement).find('.modal-body').scrollTop(0)*/);
}

export const getCookie = (name) => {
    const cookieArr = document.cookie.split(';');

    for (let i = 0; i < cookieArr.length; i++) {
        const cookiePair = cookieArr[i].split('=');

        if (name === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }

    return null;
};

export const setCookie = (name, value, days) => {
    let expires = '';

    if (days) {
        const date = new Date();

        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

export const deleteCookie = (name) => {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

